export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 20
    },
    {
      prop: 'title',
      label: '标题',
      minWidth: 150
    },
    {
      prop: 'create_time',
      label: '创建时间',
      minWidth: 100,
    },
    {
      prop: 'sorts',
      label: '权重',
      minWidth: 50,
    },
    {
      prop: 'status',
      label: '状态',
      minWidth: 150,
    },
    {
      prop: "handle",
      label: "操作",
      minWidth: 50,
    },
  ]
}


export default {}